export const VENDOR_LIST_VERSION = '2026-1';
export const CONSENT_STORAGE_KEY = 'consent_ack';

export type Vendor = {
  name: string;
  packages: string[];
  dataProcessed: string;
  regions: string;
  privacyUrl: string;
};

export type ConsentRecord = { version: string; acceptedAt: string };

export const VENDORS: Vendor[] = [
  {
    name: 'Sentry',
    packages: ['@sentry/node', '@sentry/react'],
    dataProcessed: 'Error reports, stack traces, release info',
    regions: 'US (EU relay available)',
    privacyUrl: 'https://sentry.io/privacy/',
  },
  {
    name: 'PostHog',
    packages: ['posthog-js', 'posthog-node'],
    dataProcessed: 'Page views, events, user identity',
    regions: 'US or self-hosted',
    privacyUrl: 'https://posthog.com/privacy',
  },
  {
    name: 'Unleash',
    packages: ['unleash-client', '@unleash/proxy-client-react'],
    dataProcessed: 'Feature flag evaluations, context (userId)',
    regions: 'Self-hosted or Unleash Cloud (EU/US)',
    privacyUrl: 'https://www.getunleash.io/privacy-policy',
  },
  {
    name: 'Stripe',
    packages: ['stripe', '@stripe/stripe-js'],
    dataProcessed: 'Payment data, billing identity',
    regions: 'US (PCI-DSS scope)',
    privacyUrl: 'https://stripe.com/privacy',
  },
  {
    name: 'Cronitor',
    packages: ['cronitor'],
    dataProcessed: 'Uptime pings, IP address',
    regions: 'US',
    privacyUrl: 'https://cronitor.io/privacy',
  },
  {
    name: 'Headway',
    packages: ['headwayapp.co widget'],
    dataProcessed: 'Changelog view events',
    regions: 'US',
    privacyUrl: 'https://headwayapp.co/privacy',
  },
  {
    name: 'Google OAuth',
    packages: ['via better-auth'],
    dataProcessed: 'Auth tokens, email, profile',
    regions: 'US',
    privacyUrl: 'https://policies.google.com/privacy',
  },
  {
    name: 'Facebook OAuth',
    packages: ['via better-auth'],
    dataProcessed: 'Auth tokens, email, profile',
    regions: 'US',
    privacyUrl: 'https://www.facebook.com/privacy/policy/',
  },
  {
    name: 'Apple OAuth',
    packages: ['via better-auth'],
    dataProcessed: 'Auth tokens, email',
    regions: 'US',
    privacyUrl: 'https://www.apple.com/legal/privacy/',
  },
  {
    name: 'Supabase',
    packages: ['@supabase/supabase-js'],
    dataProcessed: 'All stored application data',
    regions: 'Configurable (EU regions available)',
    privacyUrl: 'https://supabase.com/privacy',
  },
];
